module.exports = __webpack_public_path__ + "img/Slice13-min.09f07d5f.png";